import React, { FC } from "react";
import { useTranslations } from "next-intl";
import { Checkbox } from "@/components/common";
import { FilterType, ParcelCategoryUZ } from "@/enums";
import { Category } from "../get-parcels-table/components";
import { IFilterOption } from "@/types/parcel-filter.types";

type TProps = {
  value: any[];
  options: IFilterOption[];
  type: FilterType;
  handleFilterChange: (type: FilterType, value: string | number) => void;
  handleSelectAll: (type: FilterType, options: any[]) => void;
  translation: boolean;
};

const FilterResult: FC<TProps> = ({
  value,
  options,
  type,
  handleFilterChange,
  handleSelectAll,
  translation,
}) => {
  const t = useTranslations();

  return (
    <div className="absolute top-0 z-20 flex w-full items-center justify-between rounded-[26px] bg-[#f9f9f9] pt-10">
      <ul className="mt-4 max-h-[15rem] w-full overflow-y-auto overflow-x-hidden p-4">
        <li className="h-[52px] w-full border-t py-4">
          {value.length === options.length && value.length > 0 ? (
            <span
              className="cursor-pointer"
              onClick={() => {
                handleSelectAll(type, options);
              }}
            >
              {t("clear_all")}
            </span>
          ) : (
            <Checkbox
              label={t("select_all")}
              name="select all"
              secondary
              onChange={() => {
                handleSelectAll(type, options);
              }}
              checked={value.length === options.length}
            />
          )}
        </li>
        {options.map((option) => {
          const Icon = option.icon;

          return (
            <li key={option.value} className="w-full border-t py-4">
              <div className="flex items-center gap-2">
                <Checkbox
                  secondary
                  name="select all"
                  containerClassName="!w-[24px]"
                  onChange={() => {
                    handleFilterChange(type, option.value);
                  }}
                  checked={
                    value.includes(option.value) ||
                    value.length === options.length
                  }
                />
                <div
                  onClick={() => {
                    handleFilterChange(type, option.value);
                  }}
                  className="flex items-center gap-2"
                >
                  {type === FilterType.CATEGORY ? (
                    <div className="h-9 w-9">
                      <Category
                        wrapperClassName="w-9 h-9"
                        category={option.value as ParcelCategoryUZ}
                      />
                    </div>
                  ) : option.icon ? (
                    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#f9f9f9]">
                      <Icon />
                    </div>
                  ) : null}

                  <p className="ml-1 text-wrap text-base font-normal text-black">
                    {translation ? t(option.label) : option.label}
                  </p>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FilterResult;
